import '@/i18n'; // кикстартует ленивую загрузку локали как можно раньше (см. src/i18n.ts)
import addDomainReducer from '@/store/reducers/addDomainSlice';
import createWidgetSlice from '@/store/reducers/createWidgetSlice';
import domainsListReducer from '@/store/reducers/domainsListSlice';
import widgetsListReducer from '@/store/reducers/widgetsListSlice';
import historyResultReducer from '@/store/reducers/historyResultSlice';
import forgotPasswordFormReducer from '@/store/reducers/forgotPasswordFormSlice';
import loginFormReducer from '@/store/reducers/loginFormSlice';
import pageReducer from '@/store/reducers/pageSlice';
import registerFormReducer from '@/store/reducers/registerFormSlice';
import reportFormSlice from '@/store/reducers/reportFormSlice';
import { configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import authReducer from './reducers/authSlice';
import durationReducer from './reducers/durationSlice.js';
import likesReducer from './reducers/likesSlice.js';
import resultRecommendationsReducer from './reducers/resultRecommendationsSlice';
import resultReducer from './reducers/resultSlice';
import testingReducer from './reducers/testingSlice';
import testRatingFormReducer from './reducers/testRatingFormSlice';
import testRatingReducer from './reducers/testRatingSlice';
import profileSettingsReducer from './reducers/profileSettingsSlice';
import profileAvatarReducer from './reducers/profileAvatarSlice';
import accountSettingsReducer from './reducers/accountSettingsSlice';
import myTestsReducer from './reducers/myTestsSlice';
import testFavoritesReducer from './reducers/testFavoritesSlice';
import meCardsReducer from './reducers/meCardsSlice';
import testQualityReducer from './reducers/testQualitySlice';

const isProduction = process.env.NODE_ENV === 'production';

// Отдельно от store — для изолированных сторов в сторис (страница результата).
export const rootReducer = {
    page: pageReducer,
    testing: testingReducer,
    reportForm: reportFormSlice,
    likes: likesReducer,
    duration: durationReducer,
    resultRecommendations: resultRecommendationsReducer,
    result: resultReducer,
    testRating: testRatingReducer,
    testRatingForm: testRatingFormReducer,
    auth: authReducer,
    loginForm: loginFormReducer,
    registerForm: registerFormReducer,
    forgotPasswordForm: forgotPasswordFormReducer,
    historyResult: historyResultReducer,
    widgetNewDomain: addDomainReducer,
    widgetDomainsList: domainsListReducer,
    widgetsList: widgetsListReducer,
    createWidget: createWidgetSlice,
    profileSettings: profileSettingsReducer,
    profileAvatar: profileAvatarReducer,
    accountSettings: accountSettingsReducer,
    myTests: myTestsReducer,
    testFavorites: testFavoritesReducer,
    meCards: meCardsReducer,
    testQuality: testQualityReducer,
};

const store = configureStore({
    reducer: rootReducer,
    devTools: !isProduction,
})


export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

// Типизированные хуки — используйте их вместо useDispatch и useSelector
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;